import React from "react";
import { withRouter } from "react-router-dom";
import CustomerDetailComponent from "./components/customerDetail";
function CustomerDetail() {
  return <CustomerDetailComponent />;
}
export default withRouter(CustomerDetail);
